import { render } from "./TheHeader.vue?vue&type=template&id=25659c2a"
const script = {}

import "./TheHeader.vue?vue&type=style&index=0&id=25659c2a&lang=css"

import exportComponent from "/mnt/d/Projects/santanu-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__